import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/privacy/components/PrivacyContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/opt/build/repo/src/components/ui/icon.tsx");
